// ===== OCAMANI D — Scroll Reveal Bidirectionnel Lent =====
document.addEventListener('DOMContentLoaded', function () {
  const lines = Array.from(document.querySelectorAll('.ocd-reveal-line'));
  if (!lines.length) return;

  let lastScrollY = window.scrollY;

  const observer = new IntersectionObserver(
    (entries) => {
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY >= lastScrollY;
      lastScrollY = currentScrollY;

      entries.forEach((entry) => {
        const index = lines.indexOf(entry.target);

        if (entry.isIntersecting) {
          const delay = scrollingDown
            ? index * 600
            : (lines.length - 1 - index) * 600;

          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, delay);
        } else {
          entry.target.classList.remove('is-visible');
        }
      });
    },
    { threshold: 0.3 }
  );

  lines.forEach((line) => observer.observe(line));
});
// Animation gauche/droite alternée - sections Image avec texte
document.querySelectorAll('.section-image-with-text').forEach(function(section) {
  var textBlock = section.querySelector('.hero__overlay_content');
  if (!textBlock) return;

  var isReversed = section.querySelector('.hero-grid--rev') !== null;
  var translateX = isReversed ? '-60px' : '60px';

  textBlock.style.opacity = '0';
  textBlock.style.transform = 'translateX(' + translateX + ')';
  textBlock.style.transition = 'opacity 0.9s ease, transform 0.9s ease';

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateX(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(textBlock);
});


